<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    import {EventBus} from './event-bus';

    export default {
        name: 'App',
        data() {
            return {
                counter: null,
            }
        },
        created() {
            window.ontouchstart = this.countdown;
            window.onclick = this.countdown;
            window.ontouchmove = this.countdown;

            document.oncontextmenu = function () {
                return false
            };

            EventBus.$on('resetCountdown', () => {
                this.countdown()
            })
        },
        methods: {
            countdown() {
                clearTimeout(this.counter);
                this.counter = setTimeout(this.sendResetApplicationEvent, 120000); //60000
            },
            sendResetApplicationEvent() {
                EventBus.$emit('resetApplication');
                this.counter = null;
            }
        }
    }
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Roboto');

    body {
        margin: 0;
        font-family: 'Roboto', sans-serif;
        background-color: #000000;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue